


class FM3StoryHero extends HTMLElement {
  connectedCallback(){
    this.slides=[...this.querySelectorAll('[data-slide]')];
    this.dots=[...this.querySelectorAll('[data-dot]')];
    this.index=0;
    this.interval=Math.max(4000,Number(this.dataset.interval||7000));
    this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>{this.go(i);this.restart();}));
    this.addEventListener('mouseenter',()=>this.stop());
    this.addEventListener('mouseleave',()=>this.start());
    this.go(0); this.start();
  }
  go(i){this.index=i%this.slides.length;this.slides.forEach((s,n)=>{s.classList.toggle('is-active',n===this.index);const v=s.querySelector('video');if(v){if(n===this.index){v.play().catch(()=>{});}else{v.pause();}}});this.dots.forEach((d,n)=>d.classList.toggle('is-active',n===this.index));}
  start(){this.stop(); if(this.slides.length>1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches)this.timer=setInterval(()=>this.go((this.index+1)%this.slides.length),this.interval)}
  stop(){if(this.timer)clearInterval(this.timer)}
  restart(){this.start()}
}
if(!customElements.get('fm3-story-hero'))customElements.define('fm3-story-hero',FM3StoryHero);
